import { render, staticRenderFns } from "./OpportunityActionButton.vue?vue&type=template&id=85c99888&scoped=true&"
import script from "./OpportunityActionButton.vue?vue&type=script&lang=js&"
export * from "./OpportunityActionButton.vue?vue&type=script&lang=js&"
import style0 from "./OpportunityActionButton.vue?vue&type=style&index=0&id=85c99888&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85c99888",
  null
  
)

export default component.exports